import React, { useState, useEffect } from 'react';
import Banner from '../components/banner/Banner';
import About from '../components/about/About';
import Speciality from '../components/speciality/Speciality';
import Portfolio from '../components/portfolio/Portfolio';
import Pricing from '../components/pricing/Pricing';
import Footer from '../components/footer/Footer';
import Header from '../components/header/Header';
import { solutionsContent } from '../assets/data/contentData';

function Home01() {
  const [activeSolId, setActiveSolId] = useState("media");
  const content = solutionsContent[activeSolId];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activeSolId]);

  return (
    <div className="home-1 wrapper">
      <Header activeSolId={activeSolId} onSolChange={setActiveSolId} />
      
      <div key={activeSolId} style={{ animation: "brandFocus 0.8s cubic-bezier(0.2, 0.8, 0.2, 1)" }}>
        <style>{`
          @keyframes brandFocus { from { opacity: 0; transform: scale(0.98); filter: blur(15px); } to { opacity: 1; transform: scale(1); filter: blur(0); } }
        `}</style>
        
        <div id="hero"><Banner content={content} /></div>
        <div id="features"><About content={content} /></div>
        <div id="platform"><Speciality content={content} /></div>
        <div id="howit"><Portfolio content={content} /></div>
        <Pricing content={content} />
        <Footer />
      </div>
    </div>
  );
}

export default Home01;